import DOMPurify from "dompurify";

const STORY = {
  ALLOWED_TAGS: ["h3", "p", "br", "strong", "b", "em", "i", "ul", "ol", "li", "blockquote", "a"],
  ALLOWED_ATTR: ["href", "rel"],
  ALLOWED_URI_REGEXP: /^(?:https?:|mailto:)/i,
};

export const cleanStory = (html) => DOMPurify.sanitize(html || "", STORY);

export const storyFragment = (html) => DOMPurify.sanitize(html || "", { ...STORY, RETURN_DOM_FRAGMENT: true });
